import React from 'react';
import { Routes, Route } from 'react-router-dom';
import {TaskAssignmentDashboard} from './TaskAssignmentDashboard';
import {TaskAssignmentList} from './TaskAssignmentList';
import {TaskAssignmentForm} from './TaskAssignmentForm';

const TaskAssignmentIndex = () => {
  return (
    <Routes>
      <Route path="/" element={<TaskAssignmentDashboard />} />
      <Route path="/list" element={<TaskAssignmentList />} />
      <Route path="/create" element={<TaskAssignmentForm mode="create" />} />
      <Route path="/edit/:id" element={<TaskAssignmentForm mode="edit" />} />
    </Routes>
  );
};

export default TaskAssignmentIndex;